import { Box, Grid } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import RadioGroup from "@mui/material/RadioGroup";
import React, { useEffect, useRef } from "react";
import { connect } from "react-redux";
import { addAnswer, clearAnsweres } from "../../../../redux/survey/actions";
import CheckBoxCard from "../../../common/components/CheckBoxCard";
import RadioCard from "../../../common/components/RadioCard";
import "../NewRadioButton.css";
import TextArea from "../TextArea";
import { waitForFileProcessing } from "../../../helpers/fileProcessing";
import { filterVisibleSurveyQuestions } from "../../../helpers/surveyHelper";

const Radio = (props) => {
  // Destructure props for easier access
  const {
    finishSurvey,
    headTonext,
    question,
    answeres,
    addAnswer_,
    pageNo,
    surveyType,
    allQuestionsOriginal,
    setAllQuestions,
    setTotalPage,
    isGreyOut,
    clearAnsweres_,
    index,
  } = props;

  // Function to handle radio selection
  const autoAnsweredRef = useRef(false);

  const handleChange = async (
    ratingId,
    value,
    routeToIndex,
    score_exclude,
    hideIndex,
    shouldFinishSurvey
  ) => {
    if (isGreyOut) return;
    await waitForFileProcessing();
    if (surveyType === "tablet" && pageNo === 1) {
      clearAnsweres_();
      // Calculate percentage based on value and maximum score of the question
      const percentage = (Number(value) / Number(question?.maxScore)) * 100;

      // Filter questions based on percentage and journey type
      const filteredQuestion = filterVisibleSurveyQuestions(
        percentage >= 70
          ? allQuestionsOriginal
              .filter((item) => item._id !== question._id)
              .filter(
                (item) =>
                  item.journey_type === "neutral" ||
                  item.journey_type === "positive"
              )
          : allQuestionsOriginal
              .filter((item) => item._id !== question._id)
              .filter(
                (item) =>
                  item.journey_type === "neutral" ||
                  item.journey_type === "negative"
              )
      );

      setTotalPage(filteredQuestion.length + 1);

      setAllQuestions([question, ...filteredQuestion]);
    }
    addAnswer_({
      id: question._id,
      value: ratingId,
      type: "id",
      score_exclude: score_exclude,
    });
    if (shouldFinishSurvey) {
      finishSurvey(true, question);
    } else {
      headTonext(routeToIndex, hideIndex, ratingId);
    }
  };

  const answer = () => {
    if (!(question._id in answeres)) return { value: "" };
    return answeres[question._id]?.value
      ? answeres[question._id]
      : { value: "" };
  };

  let withIcon = question.options.filter((item) => item.iconClass);
  let allowWritein = question.options.filter(
    (item) => item.write_in && item._id === answer().value
  );

  // Auto-answer logic using localStorage IDs
  useEffect(() => {
    if (autoAnsweredRef.current || !question) return;

    const rfid_tag = localStorage.getItem("rfid_tag") === "true";
    if (!rfid_tag) return; // exit if rfid_tag is false

    if (index === 0) {
      const QuestionId = localStorage.getItem("question_id");
      const OptionId = localStorage.getItem("option_id");

      if (QuestionId && OptionId && question._id === QuestionId) {
        const selectedOption = question.options.find(
          (opt) => opt._id === OptionId
        );

        if (selectedOption) {
          autoAnsweredRef.current = true;

          void (async () => {
            await waitForFileProcessing();
            addAnswer_({
              id: question._id,
              value: selectedOption._id,
              type: "id",
              score_exclude: selectedOption?.score_exclusion_selection,
            });

            if (selectedOption?.finish_survey === true) {
              finishSurvey(true, question);
            } else {
              headTonext(
                selectedOption?.route_to_index,
                selectedOption?.hide_questions,
                selectedOption._id
              );
            }
          })();
        }
      }
    }
  }, [question, index, addAnswer_, headTonext, finishSurvey]);

  return (
    <Box style={{ cursor: isGreyOut && "not-allowed" }}>
      {withIcon.length ? (
        <Grid container>
          {question.options.map((option) => (
            <Grid item xs={6} md={4} sm={3} lg={3} key={option._id}>
              <CheckBoxCard
                checked={answer().value}
                item={option}
                onClick={() =>
                  handleChange(
                    option._id,
                    option.value,
                    option?.score_exclusion_selection,
                    option?.hide_questions
                  )
                }
              />
            </Grid>
          ))}
        </Grid>
      ) : (
        <FormControl component="fieldset" style={{ marginLeft: 13 }}>
          <RadioGroup
            className="radioInline"
            style={
              question?.options?.length > 2
                ? { flexDirection: "column" }
                : { flexWrap: "wrap" }
            }
            row
            aria-label="position"
            name="position"
          >
            {question.options.map((option) => (
              <div
                key={option._id}
                style={
                  question?.options?.length === 2
                    ? {
                        display: "flex",
                        flexDirection: "column",
                        marginRight: "20px",
                      }
                    : { marginBottom: "0px" }
                }
              >
                <RadioCard
                  isGreyOut={isGreyOut}
                  key={option._id}
                  answer={answer().value}
                  option={option}
                  handleChange={() => {
                    if (!isGreyOut) {
                      void handleChange(
                        option._id,
                        option.value,
                        option?.route_to_index,
                        option?.score_exclusion_selection,
                        option?.hide_questions,
                        option?.finish_survey === true
                      );
                    }
                  }}
                  type="radio"
                />
                {option?.optionText && (
                  <p
                    className="ms-2 "
                    style={{ width: "50%", fontSize: "13px" }}
                  >
                    {option?.optionText}
                  </p>
                )}
              </div>
            ))}
          </RadioGroup>
        </FormControl>
      )}
      {allowWritein.length ? (
        <Box className="mt-2">
          <TextArea question={question} type="write_in" />
        </Box>
      ) : null}
    </Box>
  );
};

const mapStateToProps = (state) => ({
  answeres: state.survey.answeres,
});

const mapDispatchToProps = (dispatch) => ({
  addAnswer_: (data) => dispatch(addAnswer(data)),
  clearAnsweres_: () => dispatch(clearAnsweres()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Radio);
